/**
 * Telegram's own alphabet for `secret_token`, and the reason the generator exists.
 *
 * setWebhook accepts 1-256 characters and ONLY these: A-Z, a-z, 0-9, `_` and `-`.
 * A secret typed by hand — or pasted from a password manager, or produced by the
 * obvious `btoa(...)` — routinely contains `+`, `/`, `=` or punctuation, and
 * Telegram then refuses the registration. The failure surfaces a minute later as
 * webhook_status = failed on the bot row, a long way from the field that caused
 * it, so generating it is what makes it impossible to get wrong.
 */
export const SECRET_ALPHABET =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';

/** 32 characters of a 64-symbol alphabet — 192 bits. */
export const SECRET_LENGTH = 32;

/**
 * A webhook secret nobody has to think about.
 *
 * crypto.getRandomValues, not Math.random: this value is the webhook route's only
 * authentication, so a predictable one lets anyone who guesses it post forged
 * payout decisions. `% 64` is unbiased precisely because the alphabet is 64 long
 * and 256 divides evenly by it — at any other alphabet length this would quietly
 * favour the first symbols.
 */
export function generateWebhookSecret() {
    const bytes = new Uint8Array(SECRET_LENGTH);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, (b) => SECRET_ALPHABET[b % SECRET_ALPHABET.length]).join('');
}
